import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppConfig} from '../shared/app-config';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {Program} from '../model/program';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';
import {Operator} from '../model/operator';

const logger = factory.getLogger('OperatorProgramsService');

@Injectable({
  providedIn: 'root'
})
export class OperatorsService {

  private operators: Observable<Program[]>;
  private operatorsLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  public findOperators(): Observable<Program[]> {
    if (this.operators && !this.operatorsLastCallError) {
      logger.debug('findOperators: Cache hit.');
    }
    this.operators = (this.operators && !this.operatorsLastCallError) ? this.operators : this.fetchOperators();
    return this.operators;
  }

  private fetchOperators(): Observable<Program[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlOperators).pipe(map(
      response => {
        const operators: Operator[] = [];

        for (const operator of response['data']) {
          if (operator.hasOwnProperty('id')) {
            if (operator.hasOwnProperty('display_label')) {
              operators.push(new Operator(operator.id, operator.display_label, operator.description, operator.status));
            } else {
              logger.error(`Operator display label is missing. Ignoring operator item from response ${operator.id}`);
            }
          } else {
            logger.error(`Operator id is missing. Ignoring operator item from response ${operator}`);
          }
        }

        logger.debug(`findOperators: ${operators.length} operators fetched from REST`);

        this.operatorsLastCallError = false;

        return operators.filter((e) => !!e.displayLabel).sort((a: Operator, b: Operator) => a.displayLabel.localeCompare(b.displayLabel));
      }
      ), catchError((err: Error | HttpErrorResponse) => {
        const message = `In OperatorsService.findOperators().`;

        this.operatorsLastCallError = true;

        return throwError(ErrorDataService.overLoadError(err, message));
      }),
      publishReplay(1),
      refCount());
  }

}
